import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import Basket from './Basket';
const basketElement = document.querySelector('[name="basket"]');
if (basketElement) {
    const employee = basketElement.getAttribute('data-employee').length > 0
        ? basketElement.getAttribute('data-employee')
        : null;
    const date = basketElement.getAttribute('data-date').length > 0
        ? basketElement.getAttribute('data-date')
        : null;
    const locked = basketElement.getAttribute('data-locked') === '1';
    render(_jsx(Basket, { preSelectedDate: date, preSelectedEmployee: employee, isPreSelectedDateLocked: locked }), basketElement);
}
